import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyBrowserTabTitle } from "../Utils/browserTabTitle";

/** Keeps `document.title` in sync with the active Gen 3 route. */
export function useBrowserTabTitle(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    applyBrowserTabTitle(pathname);
  }, [pathname]);
}
